import { render, staticRenderFns } from "./OrderCourier.vue?vue&type=template&id=ff520176&scoped=true&"
import script from "./OrderCourier.vue?vue&type=script&lang=js&"
export * from "./OrderCourier.vue?vue&type=script&lang=js&"
import style0 from "./OrderCourier.vue?vue&type=style&index=0&id=ff520176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff520176",
  null
  
)

export default component.exports